import React from 'react'

export const MobileTrackingIllustration: React.FC = () => {
  return (
    <svg
      width="400"
      height="250"
      viewBox="0 0 400 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(50, 30)">
        {/* 手机设备 */}
        <rect x="60" y="20" width="120" height="200" rx="10" fill="#333" />
        <rect x="70" y="30" width="100" height="180" rx="5" fill="white" />

        {/* 屏幕内容 - 跟踪界面 */}
        <rect x="80" y="50" width="80" height="10" rx="5" fill="#4E6BFE" />

        {/* 包裹跟踪节点 */}
        <circle cx="90" cy="80" r="5" fill="#4E6BFE" />
        <circle cx="90" cy="110" r="5" fill="#4E6BFE" />
        <circle cx="90" cy="140" r="5" fill="#FFC043" />
        <circle cx="90" cy="170" r="5" fill="#CCC" />

        {/* 连接线 */}
        <line
          x1="90"
          y1="85"
          x2="90"
          y2="105"
          stroke="#4E6BFE"
          strokeWidth="2"
        />
        <line
          x1="90"
          y1="115"
          x2="90"
          y2="135"
          stroke="#4E6BFE"
          strokeWidth="2"
        />
        <line x1="90" y1="145" x2="90" y2="165" stroke="#CCC" strokeWidth="2" />

        {/* 状态文本 */}
        <rect x="100" y="75" width="60" height="8" rx="4" fill="#4E6BFE" />
        <rect x="100" y="105" width="60" height="8" rx="4" fill="#4E6BFE" />
        <rect x="100" y="135" width="60" height="8" rx="4" fill="#FFC043" />
        <rect x="100" y="165" width="60" height="8" rx="4" fill="#CCC" />

        {/* 邮件通知 */}
        <g transform="translate(200, 100)">
          <rect x="0" y="0" width="60" height="40" rx="5" fill="#BEDCFE" />
          <path
            d="M0,0 L30,20 L60,0"
            stroke="#4E6BFE"
            strokeWidth="2"
            fill="none"
            transform="translate(0, 5)"
          />
          <line
            x1="0"
            y1="40"
            x2="25"
            y2="15"
            stroke="#4E6BFE"
            strokeWidth="2"
          />
          <line
            x1="60"
            y1="40"
            x2="35"
            y2="15"
            stroke="#4E6BFE"
            strokeWidth="2"
          />
        </g>

        {/* 通知图标 */}
        <circle cx="230" cy="70" r="15" fill="#FFC043" />
        <text
          x="230"
          y="75"
          fontFamily="Arial"
          fontSize="20"
          fill="white"
          textAnchor="middle"
        >
          !
        </text>
      </g>
    </svg>
  )
}

export default MobileTrackingIllustration
